import { useLocation, useNavigate } from 'react-router';
import type { MultiLang } from '../../config';

interface Props {
    lang: MultiLang;
}

const SelectLang = (props: Props) => {
    const { lang } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const langs: MultiLang[] = ['en', 'ja'];
    const titles = {
        en: 'English',
        ja: 'Japanese',
    };
    return (
        <div>
            <select
                value={lang}
                onChange={(e) => {
                    const xlang = e.target.value;
                    const params = new URLSearchParams(location.search);
                    params.set('ml_lang', xlang);
                    const url = `${location.pathname}?${params.toString()}`;
                    navigate(url);
                }}
            >
                {langs.map((xlang) => {
                    return (
                        <option key={xlang} value={xlang}>
                            {titles[xlang]}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default SelectLang;
